import React, { useState, useEffect } from 'react';
import { Users, Briefcase, GraduationCap, Phone, MapPin, ArrowRight, CheckCircle, Star, Award, Lightbulb } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CareersPage = () => {
  const [isVisible, setIsVisible] = useState({});


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('[id^="section-"]').forEach(section => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const currentOpenings = [
    {
      id: 1,
      title: "محامي متدرب",
      department: "القسم القانوني",
      location: "جدة",
      type: "دوام كامل",
      experience: "خريج جديد",
      description: "فرصة ممتازة للخريجين الجدد للانضمام إلى فريقنا القانوني وتطوير مهاراتهم",
      requirements: [
        "شهادة في القانون من جامعة معترف بها",
        "معدل تراكمي لا يقل عن 3.5 من 5",
        "إتقان اللغة العربية والإنجليزية",
        "مهارات تواصل ممتازة",
        "رغبة في التعلم والتطوير"
      ]
    },
    {
      id: 2,
      title: "مستشار قانوني",
      department: "قسم الاستشارات",
      location: "جدة",
      type: "دوام كامل",
      experience: "2-5 سنوات",
      description: "نبحث عن مستشار قانوني متميز لتقديم الاستشارات القانونية المتخصصة",
      requirements: [
        "شهادة في القانون من جامعة معترف بها",
        "خبرة لا تقل عن سنتين في الاستشارات القانونية",
        "إتقان اللغة العربية والإنجليزية",
        "مهارات تحليلية ممتازة",
        "قدرة على حل المشاكل القانونية المعقدة"
      ]
    },
    {
      id: 3,
      title: "محامي",
      department: "القسم القانوني",
      location: "جدة",
      type: "دوام كامل",
      experience: "3-7 سنوات",
      description: "انضم إلى فريقنا من المحامين المتميزين للعمل على قضايا متنوعة",
      requirements: [
        "شهادة في القانون من جامعة معترف بها",
        "خبرة لا تقل عن 3 سنوات في المحاماة",
        "إتقان اللغة العربية والإنجليزية",
        "مهارات الترافع والتمثيل القضائي",
        "خبرة في صياغة المستندات القانونية"
      ]
    },
    {
      id: 4,
      title: "محاسب",
      department: "القسم المالي",
      location: "جدة",
      type: "دوام كامل",
      experience: "2-5 سنوات",
      description: "نبحث عن محاسب متميز لإدارة الشؤون المالية والمحاسبية للشركة",
      requirements: [
        "شهادة في المحاسبة أو المالية من جامعة معترف بها",
        "خبرة لا تقل عن سنتين في المحاسبة",
        "إتقان برامج المحاسبة الحديثة",
        "معرفة بأنظمة الضرائب السعودية",
        "دقة في العمل واهتمام بالتفاصيل"
      ]
    },
    {
      id: 5,
      title: "مسوق",
      department: "قسم التسويق",
      location: "جدة",
      type: "دوام كامل",
      experience: "1-3 سنوات",
      description: "انضم إلى فريق التسويق لتطوير استراتيجيات تسويقية مبتكرة للخدمات القانونية",
      requirements: [
        "شهادة في التسويق أو إدارة الأعمال من جامعة معترف بها",
        "خبرة لا تقل عن سنة في التسويق",
        "مهارات في التسويق الرقمي",
        "إبداع في تطوير الحملات التسويقية",
        "مهارات تواصل ممتازة"
      ]
    }
  ];



  const benefits = [
    {
      icon: <Award className="w-8 h-8" />,
      title: "تطوير مهني مستمر",
      description: "برامج تدريبية وتطويرية متقدمة لصقل مهاراتك القانونية"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "فريق عمل متميز",
      description: "انضم إلى فريق من المحامين المتميزين والخبراء في المجال القانوني"
    },
    {
      icon: <Lightbulb className="w-8 h-8" />,
      title: "بيئة عمل إبداعية",
      description: "بيئة عمل تشجع على الإبداع والابتكار في الحلول القانونية"
    },
    {
      icon: <Star className="w-8 h-8" />,
      title: "مزايا تنافسية",
      description: "رواتب ومزايا تنافسية مع تأمين صحي وتأمين اجتماعي شامل"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
      
      {/* Header */}
      <Header />
      
             {/* Hero Section */}
       <section id="section-hero" className={`relative min-h-screen flex items-center justify-center overflow-hidden transition-all duration-1000 mt-16 md:mt-20 ${isVisible['section-hero'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ backgroundColor: '#0A3A23' }}>
         
         {/* Background Decorations */}
         <div className="absolute inset-0">
           <div className="absolute top-10 md:top-20 left-10 md:left-20 w-12 h-12 md:w-16 md:h-16 lg:w-32 lg:h-32 bg-gradient-to-br from-emerald-400/20 to-emerald-600/20 rounded-full animate-pulse"></div>
           <div className="absolute bottom-10 md:bottom-20 right-10 md:right-20 w-16 h-16 md:w-24 md:h-24 lg:w-48 lg:h-48 bg-gradient-to-br from-emerald-300/10 to-emerald-500/10 rounded-full animate-bounce" style={{animationDuration: '4s'}}></div>
           <div className="absolute top-1/3 right-1/4 w-8 h-8 md:w-12 md:h-12 lg:w-20 lg:h-20 bg-gradient-to-br from-emerald-400/20 to-emerald-600/20 rounded-full animate-ping" style={{animationDelay: '2s'}}></div>
         </div>

         <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
           <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
             {/* Content */}
             <div className="text-center lg:text-right order-2 lg:order-1 w-full">
               <div className="mb-6 md:mb-8">
                 <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
                   التوظيف
                 </h1>
                 <div className="w-20 sm:w-24 md:w-32 h-1 md:h-2 bg-gradient-to-r from-emerald-400 to-emerald-600 rounded-full mx-auto lg:mx-0"></div>
               </div>
               
               <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6 flex items-center gap-2 md:gap-4 justify-center lg:justify-start">
                 <Briefcase className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-emerald-300" />
                 <span>انضم إلى فريقنا المتميز</span>
               </h2>
               
               <div className="bg-white/10 backdrop-blur-sm p-4 md:p-6 lg:p-8 rounded-2xl md:rounded-3xl border border-white/20">
                 <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/80 leading-relaxed">
                   نبحث عن المواهب القانونية المتميزة للانضمام إلى فريقنا المتخصص. إذا كنت محامياً طموحاً وتبحث عن فرصة للتطور والنمو المهني، فأنت في المكان الصحيح.
                 </p>
               </div>
             </div>

             {/* Career Image */}
             <div className="flex justify-center order-1 lg:order-2 mb-6 lg:mb-0 w-full">
               <div className="relative">
                 <div className="w-48 h-60 sm:w-64 sm:h-80 md:w-80 md:h-96 lg:w-96 lg:h-[500px] bg-gradient-to-br from-emerald-400/30 to-emerald-600/30 backdrop-blur-sm rounded-2xl md:rounded-3xl shadow-xl md:shadow-2xl flex items-center justify-center border-2 md:border-4 border-emerald-400/30 overflow-hidden">
                   <img 
                     src="/images/صور الموقع (1)/2.jpg" 
                     alt="فريق قانوني متميز" 
                     className="w-full h-full object-cover rounded-xl md:rounded-2xl"
                   />
                   <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-xl md:rounded-2xl"></div>
                   <div className="absolute bottom-4 md:bottom-6 left-4 md:left-6 right-4 md:right-6 text-center text-white">
                     <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-3">فريق قانوني متميز</p>
                     <p className="text-xs sm:text-sm md:text-base lg:text-lg text-emerald-200">انضم إلينا اليوم</p>
                   </div>
                 </div>
                 
                 {/* Floating Elements */}
                 <div className="absolute -top-2 -right-2 sm:-top-3 sm:-right-3 md:-top-6 md:-right-6 w-6 h-6 sm:w-8 sm:h-8 md:w-12 md:h-12 lg:w-16 lg:h-16 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full animate-spin shadow-lg md:shadow-xl" style={{animationDuration: '10s'}}></div>
                 <div className="absolute -bottom-1 -left-1 sm:-bottom-2 sm:-left-2 md:-bottom-4 md:-left-4 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-12 lg:h-12 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full animate-pulse shadow-lg md:shadow-xl"></div>
               </div>
             </div>
           </div>
         </div>
       </section>

      {/* Current Openings Section */}
      <section id="section-openings" className={`py-8 md:py-16 bg-white relative transition-all duration-1000 delay-300 ${isVisible['section-openings'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}>
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6 flex items-center justify-center gap-2 md:gap-4">
              <Briefcase className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-[#0a3a23]" />
              <span>الشواغر الحالية</span>
            </h2>
            <div className="w-24 md:w-32 h-1 mx-auto rounded-full mb-4 md:mb-6" style={{ backgroundColor: '#0A3A23' }}></div>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              اكتشف الفرص المتاحة للانضمام إلى فريقنا القانوني المتميز
            </p>
          </div>

          <div className="grid lg:grid-cols-1 gap-6 md:gap-8">
            {currentOpenings.map((job) => (
              <div key={job.id} className="bg-gradient-to-r from-[#0a3a23]/5 to-[#0a3a23]/10 p-4 md:p-6 lg:p-8 rounded-2xl md:rounded-3xl border border-[#0a3a23]/20 hover:shadow-xl transition-all duration-300">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 md:gap-6">
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 md:mb-3">{job.title}</h3>
                    <p className="text-base md:text-lg text-gray-600 mb-3 md:mb-4">{job.description}</p>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6">
                      <div className="flex items-center gap-2">
                        <Briefcase className="w-4 h-4 md:w-5 md:h-5 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">{job.department}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 md:w-5 md:h-5 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">{job.location}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Users className="w-4 h-4 md:w-5 md:h-5 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">{job.type}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">{job.experience}</span>
                      </div>
                    </div>

                    <div className="mb-4 md:mb-6">
                      <h4 className="text-base md:text-lg font-semibold text-gray-800 mb-2 md:mb-3">المتطلبات:</h4>
                      <ul className="space-y-1 md:space-y-2">
                        {job.requirements.map((req, index) => (
                          <li key={index} className="flex items-center gap-2">
                            <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                            <span className="text-sm md:text-base text-gray-700">{req}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className="lg:text-center">
                    <a 
                      href={`https://wa.me/966115115945?text=أريد التقدم على وظيفة: ${job.title} - ${job.department}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full md:w-auto bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] hover:from-[#0a3a23] hover:to-[#0a3a23] text-white px-6 md:px-8 py-3 md:py-4 rounded-xl font-semibold text-base md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 group"
                    >
                      تقدم الآن
                      <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Special Talent Section */}
      <section id="section-special-talent" className={`py-8 md:py-16 bg-white relative transition-all duration-1000 delay-500 ${isVisible['section-special-talent'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}>
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6 flex items-center justify-center gap-2 md:gap-4">
              <Star className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-[#0a3a23]" />
              <span>مواهب متميزة</span>
            </h2>
            <div className="w-24 md:w-32 h-1 mx-auto rounded-full mb-4 md:mb-6" style={{ backgroundColor: '#0A3A23' }}></div>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              هل تمتلك مواهب وقدرات استثنائية؟ نحن نبحث عن المتميزين
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-[#0a3a23]/5 to-[#0a3a23]/10 p-4 md:p-6 lg:p-8 rounded-2xl md:rounded-3xl border border-[#0a3a23]/20 hover:shadow-xl transition-all duration-300">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 md:gap-6">
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 md:mb-3">هل ترى نفسك في مكان آخر؟</h3>
                  <p className="text-base md:text-lg text-gray-600 mb-3 md:mb-4">
                    إذا كنت تمتلك خبرة متميزة في مجال آخر، أو لديك رؤية جديدة يمكن أن تضيف قيمة لشركتنا، فنحن نرحب بك. نحن نؤمن بأن المواهب الحقيقية لا تقتصر على الوظائف المعلنة، بل تتجاوزها لتشمل كل من يملك الإبداع والطموح.
                  </p>
                  
                  <div className="mb-4 md:mb-6">
                    <h4 className="text-base md:text-lg font-semibold text-gray-800 mb-2 md:mb-3">نحن نبحث عن:</h4>
                    <ul className="space-y-1 md:space-y-2">
                      <li className="flex items-center gap-2">
                        <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">الأشخاص الذين يحملون أفكاراً جديدة ومبتكرة</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">خبرات متنوعة في مجالات مختلفة</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">رؤية مستقبلية لتطوير خدماتنا القانونية</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">قدرة على الإبداع والابتكار في الحلول</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <CheckCircle className="w-3 h-3 md:w-4 md:h-4 text-[#0a3a23]" />
                        <span className="text-sm md:text-base text-gray-700">الطموح والرغبة في النمو والتطوير</span>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="lg:text-center">
                  <a 
                    href="https://wa.me/966115115945?text=أنا موهبة متميز وأريد الانضمام لفريقكم - لدي خبرة في مجال مختلف وأعتقد أنني يمكن أن أضيف قيمة لشركتكم"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full md:w-auto bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] hover:from-[#0a3a23] hover:to-[#0a3a23] text-white px-6 md:px-8 py-3 md:py-4 rounded-xl font-semibold text-base md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 group"
                  >
                    تواصل معنا الآن
                    <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="section-benefits" className={`py-8 md:py-16 bg-gradient-to-br from-gray-50 to-white relative transition-all duration-1000 delay-600 ${isVisible['section-benefits'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}>
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6 flex items-center justify-center gap-2 md:gap-4">
              <Star className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-[#0a3a23]" />
              <span>لماذا تختار العمل معنا؟</span>
            </h2>
            <div className="w-24 md:w-32 h-1 mx-auto rounded-full mb-4 md:mb-6" style={{ backgroundColor: '#0A3A23' }}></div>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              اكتشف المزايا والفوائد التي نقدمها لموظفينا
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="group">
                <div className="bg-white p-6 md:p-8 rounded-2xl md:rounded-3xl border border-[#0a3a23]/20 hover:shadow-xl transition-all duration-300 cursor-pointer hover:scale-105">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-xl md:rounded-2xl mx-auto mb-4 md:mb-6 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                    {benefit.icon}
                  </div>
                  
                  <div className="text-center">
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4 group-hover:text-[#0A3A23] transition-colors">{benefit.title}</h3>
                    <p className="text-gray-700 text-sm md:text-base lg:text-lg leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>





      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة في التوظيف"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CareersPage;
